"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentBig = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const CardContent_1 = require("../CardContent");
const store_1 = require("../../utils/store");
const dompurify_1 = __importDefault(require("dompurify"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
function ContentBig({ license }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const licenseStrings = (0, store_1.stringsForLicenseType)(license.type);
    const title = (0, i18n_1.Localized)(licenseStrings.name);
    const description = (0, i18n_1.Localized)(licenseStrings.shortDescription);
    const fullDescription = t(licenseStrings.hint);
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'ContentBig_Container', children: [(0, jsx_runtime_1.jsx)(CardContent_1.Title, { "data-e2e": 'ContentBig_Title', children: title }), (0, jsx_runtime_1.jsx)(DescriptionBig, { "data-e2e": 'ContentBig_DescriptionBig', children: description }), (0, jsx_runtime_1.jsx)(FullDescription, { dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize(fullDescription),
                }, "data-e2e": 'ContentBig_FullDescription' }), (0, jsx_runtime_1.jsxs)(LinkContainer, { onClick: () => { }, role: "link", "aria-label": `${t(i18n_1.Strings.store.learnMore)}, ${t(i18n_1.Strings.store.externalLink)}`, "data-e2e": 'ContentBig_LinkContainer', children: [(0, i18n_1.Localized)(i18n_1.Strings.store.learnMore), (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.New_Window, "data-e2e": 'ContentBig_StyledIcon' })] })] }));
}
exports.ContentBig = ContentBig;
const Container = styled_components_1.default.div `
  display: flex;
  flex-flow: column;

  margin: 0 auto;
`;
const DescriptionBig = (0, styled_components_1.default)(CardContent_1.Description) `
  max-width: 324px;

  margin: 20px auto 0 auto;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    max-width: unset;

    margin: 20px auto 0 auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    max-width: 324px !important;

    margin: 30px auto 0 auto;
  `)}
`;
const FullDescription = styled_components_1.default.div `
  margin: 20px 20px 0 20px;

  color: ${props => props.theme.textSecondary};

  font-size: 14px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 20px auto 30px auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    margin: 20px auto 0 auto;
  `)}

  ul {
    position: relative;

    margin: 0;
    padding-left: 20px;

    list-style: none;

    ${ui_1.device.tablet((0, styled_components_1.css) `
      padding: 0;
    `)}
  }

  li {
    margin: 0 0 5px 0;
    display: flex;
    padding-left: 20px;

    &::before {
      position: absolute;
      left: 0;

      color: ${props => props.theme.textSecondary};

      content: '•';

      ${ui_1.device.tablet((0, styled_components_1.css) `
        position: relative;

        padding-right: 20px;
      `)}
    }
  }
`;
const LinkContainer = (0, styled_components_1.default)(atoms_1.SecondaryButton) `
  display: flex;
  justify-content: center;

  margin: auto auto 25px auto;
  border: none;

  &:focus-visible {
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin: 25px auto;
  `)}
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon).attrs({ 'aria-hidden': true }) `
  width: 14px;
  height: 14px;
  margin: 1px 6px;

  color: ${props => props.theme.greenSecondary};
`;
